// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useCreateServiceUpgradeConsent: () => UseMutationResult<
  void,
  string,
  { upgrader: string }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useMutation({
    mutationKey: ['createServiceUpgradeConsent', ledgerApi],
    mutationFn: async ({ upgrader }) => {
      return ledgerApi.createRegistryServiceUpgradeConsent(operator, upgrader);
    },
    retry: false,
  });
};

export default useCreateServiceUpgradeConsent;
